import { useNavigate } from "react-router-dom";
import { routes } from "consts";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { useToaster } from "utils";
import { blogApi, BlogPostFormValues } from "api/shop";
import { BlogPostForm } from "./Forms/BlogPostForm";
import { useState } from "react";

export const BlogPostAddPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: BlogPostFormValues) => {
    setIsLoading(true);
    try {
      const response = await blogApi.createBlogPost(data);
      showSuccess("Dodano nowy wpis");
      navigate(routes.SHOP_BLOG_EDIT(response.data?.id?.toString()));
    } catch (e) {
      showError("Nie udało się dodać nowego wpisu");
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[{ title: "Blog", path: routes.SHOP_BLOG }, { title: "Nowy wpis" }]}
        headerText="Nowy wpis"
      />
      <BlogPostForm onSubmit={onSubmit} isLoading={isLoading} />
    </PageMain>
  );
};
